import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Detectar URLs en texto
export function detectUrls(text: string): { text: string; isUrl: boolean; index: number }[] {
  if (!text || typeof text !== 'string' || text === 'N/A') {
    return [{ text, isUrl: false, index: 0 }];
  }

  // Regex para detectar URLs
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(urlRegex);
  
  return parts.map((part, index) => ({
    text: part,
    isUrl: urlRegex.test(part),
    index
  }));
}
